// Copyright (c) Move Closer 2022.

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const CART_SUMMARY_COMPONENT_KEY = 'CartSummaryComponent'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const CART_SUMMARY_DEFAULT_CONFIG = {
  buttonIcon: null,
  changedOverall: false,
  couponsLocation: 'bottom',
  freeDeliveryFrom: 99,
  shouldDisplayTotalOnMobile: true,
  showCoupons: true,
  showBenefits: false,
  showShippingPreview: false,
  showFreeDeliveryProgress: true,
  showTitle: false,
  showTaxes: true,
  subtotalWrappers: ['b'],
  taxWrappers: ['b']
}
